import axios from 'axios'
import { useEffect, useState } from 'react'
import type { SupplierRow } from './SupplierList.types'
import { mapApiDataToRows } from './helpers'

export function useSupplierData() {
  const [rows, setRows] = useState<SupplierRow[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      setError(null)

      try {
        const { data } = await axios.get<{
          count: number
          list: {
            id: number
            name: string
            type: string
            blanket: boolean
            documentsLabel: string
            documentsUrl?: string
            authorizedOems: string[]
          }[]
        }>('/supplier')

        setRows(mapApiDataToRows(data.list))
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load suppliers')
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [])

  return { rows, setRows, loading, error }
}
